import React, { useMemo } from "react";
import { alpha } from "@mui/material/styles";
import Box from "@mui/material/Box";
import { Outlet } from "react-router";
import Header from "./Header";
import { Container } from "customStyled";
import { Footer } from "components/layout/Footer";
import { SidebarDistrict } from "components/layout/sidebar";
import { selectDistrictData } from "store/slices";
import { useSelector } from "react-redux";
import AccessMessagePage from "../AccessMessagePage";
import { isValidValue } from "utils/validation";
import { useTranslation } from "react-i18next";
import PageSuspense from "routes/PageSuspense";

const Internal = (props) => {
  const { t } = useTranslation("layout");
  const { deletedAt: district_deletedAt } = useSelector(selectDistrictData);
  const footerWithSidebar = useMemo(() => <Footer withSidebar />, []);

  return (
    <React.Fragment>
      <Box sx={{ display: "flex", flexDirection: "column", height: "100vh" }}>
        <Header />
        {isValidValue(district_deletedAt) ? (
          <AccessMessagePage
            msg={t("thisDistrictIsDeactivatedPlease2")}
          />
        ) : (
          <Box sx={{ display: "flex", flexGrow: 1, marginTop: 7 }}>
            <SidebarDistrict />
            <Box
              component="main"
              sx={(theme) => ({
                flexGrow: 1,
                backgroundColor: theme.vars
                  ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
                  : alpha(theme.palette.background.default, 1),
                overflowY: "auto",
                height:
                  "calc(((1 - var(--template-frame-height, 0))* 100dvh) - 116px)",
                padding: "24px 24px 20px",
              })}
            >
              <Container sx={{ overflow: "none", height: "100%", position: "relative" }}>
                <PageSuspense><Outlet /></PageSuspense>
              </Container>
            </Box>
            {footerWithSidebar}
          </Box>
        )}
      </Box>
    </React.Fragment>
  );
};

export default Internal;
